import React from 'react';
import MediaUploadContainer from './media-upload-container';
import MediaLibraryGrid from './media-library-grid';

// Page host for the Media Library v2 (old CMS): the verify-before-save upload
// flow (SELECT -> UPLOADING -> REVIEW -> COMPLETE) on top, and a searchable grid
// of already-saved assets below. A successful commit bumps refreshKey so the grid
// re-fetches and shows the new asset.
export default class MediaLibraryHomePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { refreshKey: 0 };
    this.bumpRefresh = this.bumpRefresh.bind(this);
  }

  bumpRefresh() {
    this.setState({ refreshKey: this.state.refreshKey + 1 });
  }

  render() {
    return (
      <div>
        <MediaUploadContainer onComplete={this.bumpRefresh} />
        <MediaLibraryGrid refreshKey={this.state.refreshKey} />
      </div>
    );
  }
}
